module.exports = __webpack_public_path__ + "static/media/vikala-win.977d3093.png";